import {TranslateService} from '@ngx-translate/core';
import {Pipe, PipeTransform} from '@angular/core';
import {DipRegistrationContextService} from './dip-registration-context.service';

@Pipe({
    name: 'authTranslate',
    standalone: false
})
export class DipRegistrationAuthTranslatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService, private dipRegistrationContextService: DipRegistrationContextService
  ) {
  }

  transform(baseKey: string, interpolateParams?: any): string {
    if (this.dipRegistrationContextService.isAuthenticated()) {
      const key = `${baseKey}.authenticated`;
      const translation = this.translateService.instant(key, interpolateParams);
      if (translation !== key) {
        return translation;
      }
    }
    return this.translateService.instant(baseKey, interpolateParams);
  }
}
